<script>
  import Icono from "../UI/Icono.svelte";
  import storeTiposDeIncidencia from '../../Stores/tipos-de-incidencia-store';
  import Tooltip from "../UI/Tooltip.svelte";

  export let marcaje;
  let avisosVisibles, incidencias;

  $: tiposDeIncidencia = $storeTiposDeIncidencia.listadoIndexado
  $: incidencias = marcaje.incidencias || [];
  $: avisosVisibles = incidencias.reduce((acc, x) => ({...acc, [x.id]: false}), {});
</script>

<style>
    .incidencia {
        display: inline-block;
        margin: .25em;
        position: relative;
        --color: var(--naranja);
    }

    .incidencia .ico {
        display: inline-flex;
        border-radius: var(--radio-global);
        align-items: center;
        justify-content: center;
        padding: 5px;
        background: red;
        --color-icono: #fff;
    }
</style>

{#each incidencias as incidencia (incidencia.id)}
    <span class={`incidencia incidencia--${tiposDeIncidencia[incidencia.tipo].icono}`}>
        <span class="ico" on:mouseover={() => avisosVisibles[incidencia.id] = true}
              on:mouseleave={() => avisosVisibles[incidencia.id] = false}>
            <Icono tamano="mediano" externo
                   svg={tiposDeIncidencia[incidencia.tipo].icono + '.svg'}
                   tipo="incidencias" />
            {#if avisosVisibles[incidencia.id] }
                <Tooltip>{tiposDeIncidencia[incidencia.tipo].nombre}</Tooltip>
            {/if}
        </span>
    </span> {' '}
{/each}
